<!-- components/Breadcrumb.vue -->
<template>
    <div class="findcur">
        <el-breadcrumb separator-class="el-icon-arrow-right" separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/home' }" v-if="add">{{ additem }}</el-breadcrumb-item>
           
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="item.path"
                :to="index < breadcrumbList.length - 1 ? item.path : undefined">
                {{ item.title }}
            </el-breadcrumb-item>

            <el-breadcrumb-item :to="{ path: '/homes' }" v-if="$store.state.searchVal&&$route.path=='/search'">{{ $store.state.searchVal }}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
  
<script>
export default {
    name: 'Breadcrumb',
    data() {
        return {
            additem: '苏州站'
        };
    },
    props: {
        add: {
            type: Boolean,
            default: true
        },

    },
    computed: {
        breadcrumbList() {
            // 过滤出有 meta.title 的路由记录
            return this.$route.matched
                .filter(record => record.meta && record.meta.title)
                .map(record => ({
                    path: record.path,
                    title: record.meta.title
                }))
        }
    },
    created(){
        this.additem=localStorage.getItem('cityname')
    }
}
</script>
<style scoped lang="less">
.findcur {
    width: 1200px;
    margin: 20px auto;
    background-color: unset;
    padding: 10px 0 0;
}
</style>
  